var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPasswordCheck = function SvgIconPasswordCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    d: "M18.367 32.5H12.5c-1.033 0-1.95-.033-2.766-.15-4.384-.483-5.567-2.55-5.567-8.183v-8.334c0-5.633 1.183-7.7 5.567-8.183.816-.117 1.733-.15 2.766-.15h5.767M25.033 7.5H27.5c1.033 0 1.95.033 2.767.15 4.383.483 5.566 2.55 5.566 8.183v8.334c0 5.633-1.183 7.7-5.566 8.183-.817.117-1.734.15-2.767.15h-2.467M25 3.334v33.333M18.491 20h.015"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M11.824 20h.015"
  }))));
};
export default SvgIconPasswordCheck;